var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10,1.39534884 C5.24778239,1.39534884 1.39534884,5.24778239 1.39534884,10 C1.39534884,14.7522176 5.24778239,18.6046512 10,18.6046512 C14.7522176,18.6046512 18.6046512,14.7522176 18.6046512,10 C18.6046512,5.24778239 14.7522176,1.39534884 10,1.39534884 Z M7.74358499,11.9992836 C7.8796076,13.1337478 8.84672907,13.9977416 10,13.9977416 C11.1476397,13.9977416 12.1116922,13.1419649 12.2545505,12.014406 C12.3018808,11.6408346 12.6430891,11.376364 13.0166605,11.4236943 C13.3902319,11.4710247 13.6547026,11.812233 13.6073722,12.1858044 C13.378445,13.9926929 11.8365892,15.361378 10,15.361378 C8.15440149,15.361378 6.60761388,13.9795299 6.38964607,12.1616213 C6.34481775,11.7877414 6.61156677,11.4483113 6.98544668,11.403483 C7.35932659,11.3586547 7.69875667,11.6254037 7.74358499,11.9992836 Z M5.81395349,6.27906977 C6.58458337,6.27906977 7.20930233,6.90378872 7.20930233,7.6744186 C7.20930233,8.44504849 6.58458337,9.06976744 5.81395349,9.06976744 C5.0433236,9.06976744 4.41860465,8.44504849 4.41860465,7.6744186 C4.41860465,6.90378872 5.0433236,6.27906977 5.81395349,6.27906977 Z M14.1860465,6.27906977 C14.9566764,6.27906977 15.5813953,6.90378872 15.5813953,7.6744186 C15.5813953,8.44504849 14.9566764,9.06976744 14.1860465,9.06976744 C13.4154166,9.06976744 12.7906977,8.44504849 12.7906977,7.6744186 C12.7906977,6.90378872 13.4154166,6.27906977 14.1860465,6.27906977 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.2119f07bf0031584d09b659f944147bc.svg";
export { ForwardRef as ReactComponent };